module.exports = __webpack_public_path__ + "img/clothing23.37130837.jpg";